import classNames from 'classnames'
import React from 'react'
import { makeStyles } from 'tss-react/mui'
import { ExtendableStyles, Testable } from 'utils-next/types'

import { CardContent, Divider, Theme } from '@mui/material'

import {
  ScoutingCampaignHeaderBackButton,
  ScoutingCampaignHeaderInfo,
  ScoutingCampaignHeaderLoading,
} from './components'
import { useScoutingCampaignDetailsViewStore } from './ScoutingCampaignDetailsView.store'

export type ScoutingCampaignDetailsViewHeaderProps = ExtendableStyles & Testable

export function ScoutingCampaignDetailsViewHeader({
  className,
  style,
  ...otherProps
}: ScoutingCampaignDetailsViewHeaderProps) {
  const { classes } = useStyles()
  const {
    state: { scoutingCampaign, status },
  } = useScoutingCampaignDetailsViewStore()
  const isLoading = status === 'loading' && !scoutingCampaign
  return (
    <CardContent component="header" className={classNames(className, classes.container)} {...otherProps}>
      <ScoutingCampaignHeaderBackButton className={classes.backButton} />
      <Divider className={classes.divider} orientation="vertical" flexItem />
      {isLoading ? (
        <ScoutingCampaignHeaderLoading className={classes.headerContent} />
      ) : (
        <ScoutingCampaignHeaderInfo className={classes.headerContent} scoutingCampaign={scoutingCampaign!} />
      )}
    </CardContent>
  )
}

const useStyles = makeStyles()(({ spacing }: Theme) => ({
  container: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    padding: spacing(),
  },
  backButton: {
    flex: '0 0 auto',
  },
  divider: {
    margin: spacing(0, 2),
  },
  headerContent: {
    flex: '1 1 auto',
  },
}))
